import { LatLngBounds } from 'leaflet';
import PropTypes from 'prop-types';

import latlngList from './latlngList';

export default PropTypes.oneOfType([PropTypes.instanceOf(LatLngBounds), latlngList]);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/es/propTypes/bounds.js
// module id = 173
// module chunks = 0